export default function CatchAll() {
	return (
		<>
			<h1>Page Not Found</h1>
			<a href="/app">Go Back to Home</a>
		</>
	);
}